/**

Coded by www.nikam-shreyas.com

*/

import { useState, useEffect } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

import authService from "services/auth-service";
import crudsService from "services/cruds-service";
import { Alert, Snackbar } from "@mui/material";

function CouponCode() {
  const [notification, setNotification] = useState({
    value: false,
    color: "info",
    message: "",
  });
  const [user, setUser] = useState({});

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const user = await authService.getProfile();
        setUser(user.data.id);
      } catch (error) {
        console.error("Error fetching user profile:", error);
      }
    };
    fetchUser();
  }, []);

  const [info, setInfo] = useState({ couponCode: "" });

  useEffect(() => {
    let timer;
    if (notification.value === true) {
      timer = setTimeout(() => {
        setNotification({ value: false, color: "info", message: "" });
      }, 5000);
    }
    return () => clearTimeout(timer); // Cleanup function
  }, [notification]);

  const [errors, setErrors] = useState({
    invalidCouponError: false,
  });

  const changeHandler = (e) => {
    setInfo({
      ...info,
      [e.target.name]: e.target.value,
    });
    setErrors({
      invalidCouponError: false,
    });
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    // validation
    if (info.couponCode.trim() === "") {
      setErrors({
        invalidCouponError: true,
      });
      return;
    }

    try {
      await crudsService.checkCoupon(info.couponCode);
      const response = await crudsService.applyCouponCode({
        couponCode: info.couponCode,
        userId: user,
      });
      if (response.message === "Coupon applied successfully") {
        setNotification({
          value: true,
          color: "success",
          message: "Your Access Code has been successfully applied.",
        });
      } else {
        setNotification({
          value: true,
          color: "error",
          message: "Something went wrong. Please try again later.",
        });
      }
    } catch (error) {
      setNotification({
        value: true,
        color: "error",
        message: error.message,
      });
    }

    setInfo({ couponCode: "" });

    // reset errors
    setErrors({
      invalidCouponError: false,
    });
  };

  useEffect(() => {
    if (notification.value === true) {
      let timer = setTimeout(() => {
        setNotification({ value: false, color: "info", message: "" });
      }, 5000);
    }
  }, [notification]);

  return (
    <>
      {notification.value === true && (
        <Snackbar open>
          <Alert
            variant="filled"
            sx={{ width: "100%" }}
            color={notification.color}
          >
            {notification.message}
          </Alert>
        </Snackbar>
      )}
      <Card id="coupon-code">
        <MDBox p={3}>
          <MDTypography variant="h5">Apply Access Code</MDTypography>
        </MDBox>
        <MDBox component="form" pb={3} px={3} onSubmit={submitHandler}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <MDInput
                fullWidth
                label="Access Code"
                inputProps={{ type: "text" }}
                name="couponCode"
                value={info.couponCode}
                onChange={changeHandler}
                error={errors.invalidCouponError}
              />
              {errors.invalidCouponError && (
                <MDTypography
                  variant="caption"
                  color="error"
                  fontWeight="light"
                  pl={2}
                >
                  {info.couponCode.length === 0
                    ? "Access Code is required."
                    : "Invalid or Expired Access Code."}
                </MDTypography>
              )}
            </Grid>
          </Grid>
          <MDBox mt={3} />
          <MDButton
            variant="gradient"
            color="success"
            size="small"
            type="submit"
          >
            Apply Access Code
          </MDButton>
        </MDBox>
      </Card>
    </>
  );
}

export default CouponCode;
